export default function(d) {
  return d;
}



//////////////////
// WEBPACK FOOTER
// ./packages/layout/node_modules/d3-shape/src/identity.js
// module id = 414
// module chunks = 0